module.exports = "https://static.wagwalking.com/_next/static/images/cat-sitting-2-027184cc1c3136beedb6fc7406ff7e97.svg";